//const today = new Date();
//const current_datetime = new Date(today.toString().replace(/-/g, '/'));


export const inputsBuilder = [

    {
        'name' : 'signer_tz',
        'label' : 'תעודת זהות',
        'type' : 'number',
        'defaultValue': '',
        
        
    },
    {
        'name' : 'signer_fullName',
        'label' : 'שם מלא',
        'defaultValue': ''
    },
    {
        'name' : 'signer_address',
        'label' : 'כתובת',
        'defaultValue': '',
        //'noCkeck' : true
    },
    {
        'name' : 'money',
        'label' : 'שכר',
        'defaultValue': '',
        //'noCkeck' : true
    },
]


/* 

signer_address: '',
        signer_passport: '',
        date_birth: formApiData?.signer.date_birth ? convertDBDate(formApiData.signer.date_birth) : current_datetime,
        date_aliya: current_datetime,
        sex: 'מין', */